import { useState } from 'react'
import { IconDots, IconX } from '@tabler/icons-react'
import classNames from 'classnames'
import { SnackbarProps } from './Snackbar.types'

export const Snackbar = ({ isVisible, primary, secondary }: SnackbarProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const toggleIsOpen = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div
      className={classNames(
        'fixed left-0 w-screen lg:pl-0 px-4 transition-all z-[53]',
        !isVisible
          ? '-bottom-6 invisible opacity-0'
          : 'bottom-6 visible opacity-100'
      )}>
      <div className='w-full flex items-center justify-between px-4 py-3.5 bg-background-primary-muted text-white rounded-md relative 3xl:max-w-[872px] 2xl:max-w-[848px] lg:max-w-3xl mx-auto border border-white'>
        <div>{primary}</div>
        <div
          className={classNames(
            isOpen
              ? 'block absolute left-0 bottom-[60px] md:p-0 p-4 bg-primary-blue rounded-md md:w-auto w-full md:static'
              : 'hidden',
            'md:block md:static'
          )}>
          {secondary}
        </div>
        <button
          type='button'
          onClick={toggleIsOpen}
          className='block md:hidden text-white'>
          {isOpen ? <IconX size={24} /> : <IconDots size={24} />}
        </button>
      </div>
    </div>
  )
}
